// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5068":"46e2e0a8","5407":"2842525f"}[chunkId] + ".chunk.css";
};